<template>
  <router-link to="/ads-setting" tag="li"
    ><a><i class="fa fa-gear"></i><span>Konfigurasi Iklan</span></a></router-link
  >
</template>

<script>
// import itembankService from '@/services/itembank.js'
// import bimbelService from '@/services/bimbel.js'
// import SubNavigation from '@/components/itembank/SubNavigation'

export default {
  name: "iklan-nav",
  components: {
    // 'subnavigation': SubNavigation
  },
  data: function () {
    return { items: [] };
  },
  mounted: function () {},
};
</script>



// WEBPACK FOOTER //
// Navigation.vue?ff9feb84